import React from "react";
import _ from "lodash";
import Img from "react-image";
import Close from "../../../../../Icons/Close";
import imgUrlAvatar from "../../../../../styles/img/enfant-avatar.jpg";
import srcIconCheck from "../../../../../styles/img/icon-check-white.svg";
import { isNumber } from "util";
import { styles } from "../../../../../ReactConst";
import { StyleRoot } from "radium";
function jsUpperCaseFirst(string) {
  return _.isEmpty(string) ? string : string.charAt(0).toUpperCase();
}
function notEmpty(value) {
  return !_.isEmpty(value);
}
const divStyleAvatar = {
  color: "white",
  backgroundImage: `url(${imgUrlAvatar})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  backgroundSize: "cover",
  position: "relative",
  width: "65px",
  height: "55px",
};
const divStyleDynamicAvatar = (kid) => {
  return {
    color: "white",
    backgroundImage: `url(${kid.kid.lienPhoto})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "cover",
    position: "relative",
    width: "65px",
    height: "55px",
  }
}
class ModalMultiple extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disablePresent: false,
      disableInscrit: false,
      tabActive: "",
      Modal: false,
      filterPresent: "",
      readySubmit: false,
      childChecked: false,
      listChild: [],
      noCheck: true,
      listPresent: [],
      firstInit: false,
      presentIds: [],
      styleFadeIn: true,
    };
    this.handleTab = this.handleTab.bind(this);
    this.handleFilterKids = this.handleFilterKids.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleStyle = this.handleStyle.bind(this);
    this.handleCheckKids = this.handleCheckKids.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.activeActivite = this.activeActivite.bind(this);
    this.activeMessage = this.activeMessage.bind(this);
    this.activeRepas = this.activeRepas.bind(this);
    this.activeSieste = this.activeRepas.bind(this);
    this.activeChoixPresent = this.activeChoixPresent.bind(this);
    this.activeChoixInscrit = this.activeChoixInscrit.bind(this);
  }

  toggle() {
    this.setState({
      styleFadeIn: false,
      readySubmit: false,
      tabActive: "",
      filterPresent: "",
    });
    setTimeout(() => {
      this.props.toggle();
    }, 500);
  }

  handleStyle() {
    let tabSubmit;
    this.state.tabActive === "" ? (tabSubmit = false) : (tabSubmit = true);
    return (this.state.readySubmit &&
      notEmpty(this.state.listChild) &&
      tabSubmit) ||
      (this.state.readySubmit &&
        notEmpty(this.state.filterPresent) &&
        tabSubmit)
      ? { opacity: 1 }
      : { opacity: 0.25, pointerEvents: "none" };
  }

  handleTab(string) {
    this.setState({ tabActive: string });
  }
  activeSieste(string) {
    return this.state.tabActive === string ? "active" : "";
  }
  activeRepas(string) {
    return this.state.tabActive === string ? "active" : "";
  }
  activeActivite(string) {
    return this.state.tabActive === string ? "active" : "";
  }
  activeMessage(string) {
    return this.state.tabActive === string ? "active" : "";
  }

  activeChoixPresent(string) {
    return this.state.filterPresent === string ? "active" : "";
  }

  activeChoixInscrit(string) {
    return this.state.filterPresent === string ? "active" : "";
  }

  handleFilterKids(event) {
    event.preventDefault();
    let newPresent = this.state.listPresent.map((kid) => ({
      kid: kid.kid,
      checked: false,
    }));
    let prev_filterPresent = this.state.filterPresent;
    let reCheckSubmit = true;
    if (event.target.value === "PRESENT") {
      if (prev_filterPresent === "PRESENT") {
        prev_filterPresent = "";
        reCheckSubmit = false;
      } else if (
        _.isEmpty(prev_filterPresent) ||
        prev_filterPresent === "TOUS"
      ) {
        prev_filterPresent = "PRESENT";
        reCheckSubmit = true;
      }
      this.setState({
        listPresent: newPresent,
        noCheck: false,
        readySubmit: reCheckSubmit,
        listChild: [],
        filterPresent: prev_filterPresent,
      });
    } else if (event.target.value === "TOUS") {
      if (prev_filterPresent === "TOUS") {
        prev_filterPresent = "";
        reCheckSubmit = false;
      } else if (
        _.isEmpty(prev_filterPresent) ||
        prev_filterPresent === "PRESENT"
      ) {
        prev_filterPresent = "TOUS";
        reCheckSubmit = true;
      }
      this.setState({
        listPresent: newPresent,
        noCheck: false,
        readySubmit: reCheckSubmit,
        listChild: [],
        filterPresent: prev_filterPresent,
      });
    }
  }

  handleCheckKids(event) {
    let list = [];
    let subList = [];
    let newPresent = this.state.listPresent.map((kid) =>
      this.state.listChild.includes(parseInt(event.target.value)) &&
      kid.kid.id === parseInt(event.target.value)
        ? { kid: kid.kid, checked: false }
        : kid.kid.id === parseInt(event.target.value)
        ? { kid: kid.kid, checked: true }
        : kid
    );
    list = this.state.listChild.filter(
      (element) => element !== parseInt(event.target.value) && isNumber(element)
    );
    this.state.listChild.includes(parseInt(event.target.value)) &&
    isNumber(parseInt(event.target.value))
      ? (subList = [...list])
      : (subList = [...list, parseInt(event.target.id)]);
    this.setState({
      listPresent: newPresent,
      filterPresent: "",
      listChild: [...subList],
      readySubmit: true,
      noCheck: true,
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    let { listChild, tabActive, filterPresent, presentIds } = this.state;
    let kidsIDs = this.props.kidsIDs;
    let lastArrived = this.props.lastArrived;
    let presentIdsList = [];
    this.props.kids.forEach((kid) => {
      if (!_.isEmpty(kid.agenda)) {
        if (kid.agenda.statutDetails.statut === "PRESENT") {
          presentIdsList.push(kid.id);
        }
      }
    });
    let presentNames = [];
    let data;
    if (filterPresent === "PRESENT") {
      presentNames.push("Tous les présents");
      data = {
        listChild: presentIdsList,
        tabActive,
        lastArrived,
        presentNames,
      };
    } else if (filterPresent === "TOUS") {
      presentNames.push("Tous les inscrits");
      tabActive == "repas-tab" ||
      tabActive == "activite-tab" ||
      tabActive == "sieste-tab"
        ? (data = {
            listChild: presentIdsList,
            tabActive,
            lastArrived,
            presentNames,
          })
        : (data = { listChild: kidsIDs, tabActive, lastArrived, presentNames });
    } else {
      this.props.kids.forEach((kid) => {
        if (listChild.includes(kid.id)) {
          presentNames.push(kid.prenom);
        }
      });
      data = { listChild: listChild, tabActive, lastArrived, presentNames };
    }

    this.setState({
      styleFadeIn: false,
    });

    setTimeout(() => {
      this.props.handleMultiSubmit(data);
    }, 500);
  }

  componentDidUpdate() {
    if (!this.state.firstInit && !_.isEmpty(this.props.kids)) {
      let listPresent = [];
      let presentIdsList = [];
      this.props.kids.forEach((kid) => {
        if (!_.isEmpty(kid.agenda)) {
          if (kid.agenda.statutDetails.statut === "PRESENT") {
            presentIdsList.push(kid.id);
            listPresent.push({ kid, checked: false });
          }
        }
      });
      this.setState(
        {
          firstInit: true,
          listPresent: listPresent,
          presentIds: presentIdsList,
        },
        () => {
          if (_.isEmpty(listPresent)) {
            this.setState({ disablePresent: true });
          }
        }
      );
    } else if (!this.state.firstInit && _.isEmpty(this.props.kids)) {
      this.setState({ disableInscrit: true, disablePresent: true });
    }
  }

  closeAddModal = () => {
    this.setState({
      styleFadeIn: false,
    });

    setTimeout(() => {
      this.props.CloseModalEdit();
    }, 500);
  };
  componentWillMount() {
    this.setState({ styleFadeIn: true });
  }

  render() {
    const { isOpen, kids } = this.props;
    const IconCheckWhite = () => (
      <Img src={srcIconCheck} className="img-fluid" />
    );

    {
      return isOpen ? (
        <StyleRoot>
          <div
            className="modal show modal-skin active"
            style={
              this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
            }
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <form>
                  <button
                    onClick={this.toggle}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <Close className="img-fluid" alt="" />
                  </button>
                  <div className="modal-body">
                    <section>
                      <h5 className="modal-title">
                        Que souhaitez-vous saisir ?
                      </h5>
                      <div className="d-flex align-items-center justify-content-between choices-elts mb-4">
                        <div
                          className={`choice repas ${this.activeRepas(
                            "repas-tab"
                          )}`}
                          value="repas"
                          onClick={() => this.handleTab("repas-tab")}
                        >
                          <label htmlFor="repas">Repas</label>
                          <input
                            type="radio"
                            value="repas"
                            name="choice-elt"
                            id="repas"
                          />
                        </div>

                        <div
                          className={`choice sieste ${this.activeSieste(
                            "sieste-tab"
                          )}`}
                          value="sieste"
                          onClick={() => this.handleTab("sieste-tab")}
                        >
                          <label htmlFor="sieste">Sieste</label>
                          <input
                            type="radio"
                            value="sieste"
                            name="choice-active"
                            id="sieste"
                          />
                        </div>

                        <div
                          className={`choice activite ${this.activeActivite(
                            "activite-tab"
                          )}`}
                          value="activite"
                          onClick={() => this.handleTab("activite-tab")}
                        >
                          <label htmlFor="activite">Activite</label>
                          <input
                            type="radio"
                            value="activite"
                            name="choice-elt"
                            id="activite"
                          />
                        </div>

                        <div
                          className={`choice message ${this.activeMessage(
                            "message-tab"
                          )}`}
                          value="message"
                          onClick={() => this.handleTab("message-tab")}
                        >
                          <label htmlFor="message">Message</label>
                          <input
                            type="radio"
                            value="message"
                            name="choice-elt"
                            id="message"
                          />
                        </div>
                      </div>
                    </section>
                    <section>
                      <h5 className="modal-title">Pour qui ?</h5>
                      <div className="row mx-n2 d-flex align-items-center justify-content-between">
                        <div className="col-md-6 px-2">
                          <button
                            disabled={this.state.disablePresent}
                            className={`btn-white btn-border cible presents ${this.activeChoixPresent(
                              "PRESENT"
                            )}`}
                            value="PRESENT"
                            onClick={this.handleFilterKids}
                          >
                            Tous les présents
                          </button>
                        </div>
                        <div className="col-md-6 px-2">
                          <button
                            disabled={this.state.disableInscrit}
                            className={`btn-white btn-border cible inscrits ${this.activeChoixInscrit(
                              "TOUS"
                            )}`}
                            value="TOUS"
                            onClick={this.handleFilterKids}
                          >
                            Tous les inscrits
                          </button>
                        </div>
                      </div>
                      <ul className="row mx-n2 list-enfants">
                        {this.state.listPresent.map((kid, index) => (
                          <li className="col-md-6 px-2" key={index}>
                            <input
                              type="checkbox"
                              checked={kid.checked}
                              id={`${kid.kid.id}`}
                              value={`${kid.kid.id}`}
                              onChange={this.handleCheckKids}
                            />
                            <label
                              className="rounded15 box-shadow"
                              htmlFor={`${kid.kid.id}`}
                            >
                              <span
                                className="avatar"
                                style={divStyleDynamicAvatar(kid)}
                              ></span>
                              <span className="name">
                                {kid.kid.prenom +
                                  " " +
                                  jsUpperCaseFirst(kid.kid.nom) +
                                  "."}
                              </span>
                            </label>
                          </li>
                        ))}
                      </ul>
                    </section>
                    <div className="d-flex justify-content-center">
                      <button
                        type="submit"
                        className="btn-gradient btn-valid"
                        onClick={(event) =>
                          this.handleSubmit(event, this.state.presentIds)
                        }
                        style={this.handleStyle()}
                      >
                        <IconCheckWhite /> Valider
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>{" "}
        </StyleRoot>
      ) : (
        ""
      );
    }
  }
}

ModalMultiple.propTypes = {};

export default ModalMultiple;
